module.exports = __webpack_public_path__ + "img/127.23871731.jpg";